/**
 * This sets defaults and handles maintaining our auth token/params
 * between http requests.
 */

import Vue from 'vue'
import VueResource from 'vue-resource'
Vue.use(VueResource);


const newsletterUnSub = Vue.resource('newsletters/remove{/id}');

export default newsletterUnSub;



// WEBPACK FOOTER //
// ./src/resources/newsletterUnSub.js